export default function UploadProgressOverlay({ open, percent = 0 }) {
  if (!open) return null;
  const pct = Math.max(0, Math.min(100, Math.round(Number(percent) || 0)));
  return (
    <div
      className="fixed inset-0 z-[95] flex items-center justify-center bg-slate-950/55 backdrop-blur-sm p-4"
      data-testid="upload-progress-overlay"
    >
      <div className="bg-white rounded-2xl shadow-xl px-7 py-6 w-full max-w-sm text-center">
        <div className="text-sm font-semibold text-slate-900" data-testid="upload-progress-label">
          Please wait — uploading {pct}%
        </div>
        <div className="mt-3 h-2 rounded-full bg-slate-100 overflow-hidden">
          <div
            className="h-full rounded-full bg-blue-600 transition-all duration-150"
            style={{ width: `${pct}%` }}
            data-testid="upload-progress-bar"
          />
        </div>
      </div>
    </div>
  );
}
